import { Container, Card, Col } from 'react-bootstrap';
import TituloNegrito from './TituloNegrito'

import { retornarTexto } from '../helpers/textoHelper'

import imgDefaultNoticias from '../images/default_noticias.png'

function Noticias({ noticias, resolucaoMobile, idioma }) {
    const dimensionsImage = '200px'
    const stylesImage = { width: dimensionsImage, height: dimensionsImage, objectFit: 'cover', borderRadius: '8px', marginBottom: resolucaoMobile ? '30px' : '16px' }

    return (
        <Container className="my-5">
            <TituloNegrito texto={retornarTexto(idioma, 'noticias')} />

            <div>
                {noticias.map((noticia) => (
                    <Card style={{ background: 'transparent', border: '1px solid white', color: 'white'}} key={noticia['Título']} className=" d-flex align-items-center justify-content-center mb-3 animate__animated animate__fadeInUp">

                        <Card.Body className={`d-flex ${resolucaoMobile && 'flex-column'} align-items-center justify-concent-center`}>
                            {noticia['Link da imagem'] ?
                                <Card.Img className='mt-3' style={stylesImage} variant="top" src={noticia['Link da imagem']} alt={`Imagem da notícia`} />
                             : <Card.Img className='mt-3' style={stylesImage} variant="top" src={imgDefaultNoticias} alt={`Imagem da notícia`} />}
                            <div>
                                <Card.Title className='fw-bold' >{noticia['Título']}</Card.Title>
                                <Card.Text>{noticia['Descrição']}</Card.Text>
                                <a href={noticia['Link']} target="_blank" rel="noopener noreferrer" className={`btn btn-light ${resolucaoMobile && 'mb-3'}`}>
                                    {retornarTexto(idioma, 'leiaMais')}
                                </a>
                            </div>
                        </Card.Body>
                    </Card>
                ))}
            </div>
        </Container>
    );
}

export default Noticias;